import { InputAdornment, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const MonthlyLodgingAmount = () => {
  const { control, getValues, setValue } = useFormContext();
  const { t } = useTranslation();
  const actualHousingType: string = useWatch({ name: 'actualHousingType' });
  const amountToTraveler: number = useWatch({ name: 'amountToTraveler' });

  useEffect(() => {
    if (actualHousingType === t('placement.placementMods.subsidy')) {
      const lodgingAmount =
        amountToTraveler > 0
          ? Math.round((amountToTraveler * 365) / 12 + 0.0000000025).toFixed(2)
          : Number(amountToTraveler).toFixed(2);

      setValue('monthlyLodgingAmount', lodgingAmount);
    } else {
      setValue('monthlyLodgingAmount', '');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amountToTraveler, actualHousingType]);

  return (
    <Controller
      control={control}
      name={'monthlyLodgingAmount'}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          variant="filled"
          fullWidth
          id="amountToTraveler"
          color="primary"
          autoComplete="off"
          label={t('placement.placementMods.monthlyLodgingAmount')}
          InputProps={{
            readOnly: true,
            style: {
              pointerEvents: 'none',
            },
            startAdornment: <>{value && <InputAdornment position="start">$</InputAdornment>}</>,
          }}
          value={getValues('monthlyLodgingAmount') ?? ''}
          {...rest}
        />
      )}
    />
  );
};
